(function () {
    'use strict';

    // @ngInject
    Controllers.BlockConfirmController = function BlockConfirmController($modalInstance) {
        this.sendEmails = true;

        this.ok = function ok() {
            $modalInstance.close(this.sendEmails);
        };

        this.cancel = function cancel() {
            $modalInstance.dismiss('cancel');
        };
    };

}());